import React, { useState, useEffect, FC } from "react";
import { RootState } from "store/reducers/types";
import { connect } from "react-redux";
import "./profileIcon.scss";

interface StateProps {
  isAuthenticated: boolean;
  userName?: string;
};

interface OwnProps {
  className: string;
}

type ProfileIconProps = StateProps & OwnProps;

const nameToInitials = (fullName: string) => {
  return fullName
    .split(" ")
    .map((part: string) => part.charAt(0))
    .join("")
    .substr(0, 2);
};

const ProfileIcon: FC<ProfileIconProps> = ({ userName: uName, isAuthenticated, className = '' }: ProfileIconProps) => {
  const [userName] = useState<string | undefined>(uName);
  const [initials, setInitials] = useState<string>('');

  useEffect(() => {
    if (!userName) return;

    setInitials(nameToInitials(userName));
  }, [userName]);

  if (!isAuthenticated || !initials) {
    return null;
  };

  return (
    <div className={`profile-icon ${className}`.trim()}>{initials}</div>
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  userName: state.session.userName,
  isAuthenticated: state.session.isAuthenticated
});

export default connect<StateProps, null, OwnProps, RootState>(mapStateToProps)(ProfileIcon);
